import { IconFilter, IconPlus } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SquareIconButton } from '../../../../../../components/button'
import { TableStanderd } from '../../../../../../components/table'
import { showErrorToast } from '../../../../../../components/toast'
import { useRESTapi } from '../../../../../../controller/restAPI'
import { accountLedgerDef, partyDef, squareButtonVarient, themeStateDef } from '../../../../../../definitions/definintion'
import { setTopNavText } from '../../../../../../redux/config/configSlice'
import { ModalAddBranch, ModalBranchDetails } from './components/modals'
import MenuSimple from '../../../../../../components/menu'
import { InputStd2, SelectBoxInputBox } from '../../../../../../components/inputs'
import { formatNumberWithCommas } from '../../../../../../controller/format'

export function AccountLedgerCRUD() {

    const [showAddModal, setShowAddModal] = useState(false)
    const [showDetailsModal, setShowDetailsModal] = useState(false)
    const [selectedEmploye, setSelectedEmploye] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [updateUi, setUpdateUi] = useState(false)
    const [showFilterModal, setShowFilterModal] = useState(false)
    const searchParamDef = {
        fromDate: 'from_date',
        toDate: 'to_date',
        ledgerId: accountLedgerDef.AccountLedgerId,
    }
    const [ledgers, setLedgers] = useState([])
    const [searchParams, setSearchParams] = useState({
        [searchParamDef.ledgerId]: '',
        [searchParamDef.fromDate]: '',
        [searchParamDef.toDate]: '',
    })
    const [rows1, setRow1] = useState([
        // {
        //     id: '1',
        //     data: {
        //         [accountLedgerDef.LedgerName]: 'Abu',
        //         [accountLedgerDef.OpeningBalance]: '10000',
        //         [accountLedgerDef.CreditPeriod]: '12000',
        //         [accountLedgerDef.CreditLimit]: '13000',
        //         [accountLedgerDef.AccountGroupId]: 'sample',
        //         [accountLedgerDef.IsDefault]: 'sample',
        //         [accountLedgerDef.CrOrDr]: 'sample',
        //         [accountLedgerDef.Narration]: 'sample',
        //         [accountLedgerDef.MailingName]: 'sample',
        //         [accountLedgerDef.Address]: 'sample',
        //         [accountLedgerDef.Phone]: 'sample',
        //         [accountLedgerDef.Mobile]: 'sample',
        //         [accountLedgerDef.Email]: 'sample',
        //         [accountLedgerDef.IsActive]: 1,
        //     }
        // },
    ])
    const api = useRESTapi()
    const onChangeSearchParams = (event) => {
        searchParams[event.target.name] = event.target.value;
        console.log(searchParams)
        setSearchParams({
            ...searchParams
        })
    }

    const rebuildUi = () => {
        setUpdateUi(!updateUi)
    }
    const dispatch = useDispatch()



    useEffect(
        () => {

            const initialLoad = async () => {
                setIsLoading(true)
                try {

                    const res1 = await api.get({
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/account-ledgers`
                    })
                    if (res1.data.success === true) {
                        setLedgers([
                            {
                                name: 'ALL',
                                value: null,
                            },
                            ...res1.data.data.map(items => ({
                                name: items[accountLedgerDef.LedgerName],
                                value: items[accountLedgerDef.AccountLedgerId],
                            }))
                        ])
                    } else {
                        showErrorToast({
                            message: res1.data.message
                        })
                        setIsLoading(false)
                        return;
                    }

                    const res = await api.get({
                        url: `${process.env.REACT_APP_BACKEND_URL}/api/account-ledgers`,
                        params: {
                            [searchParamDef.ledgerId]: searchParams[searchParamDef.ledgerId],
                            [searchParamDef.fromDate]: searchParams[searchParamDef.fromDate],
                            [searchParamDef.toDate]: searchParams[searchParamDef.toDate],
                        }
                    })
                    // const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/account-ledgers`,{headers});
                    const acLedger = res.data.data;

                    const rows = acLedger.map(
                        (emp,index) => {
                            emp['SerialNo'] = index+1
                            emp['commaOpening'] = formatNumberWithCommas(emp[accountLedgerDef.OpeningBalance])
                            return ({
                                id: emp[accountLedgerDef.AccountLedgerId],
                                data: emp
                            })
                        }
                    )
                    setRow1(rows)


                } catch (error) {
                    console.log(error)
                    showErrorToast({
                        message: error.response?.data?.message || error.message?.msg || 'something went wrong',
                        showAtTimeOne: true,
                        id: 'accountLedger',
                        timeOut: 5000
                    })
                }
                setIsLoading(false)
            }

            initialLoad()
            dispatch(setTopNavText('Account Ledger'))
            return () => {
                dispatch(setTopNavText(''))
            }

        }, [updateUi]
    )

    const headers = [

        {
            id: '4',
            name: 'No',
            label: 'SerialNo'
        },
        {
            id: '3',
            name: 'Name',
            label: accountLedgerDef.LedgerName
        },
        {
            id: '1',
            name: 'Opening Balance',
            label: 'commaOpening'
        },
        {
            id: '2',
            name: 'email',
            label: accountLedgerDef.Email
        },
        {
            id: '5',
            name: 'Mobile',
            label: accountLedgerDef.Mobile
        },

    ]

    const openDetailsModal = (id, index) => {
        setSelectedEmploye(id)
        setShowDetailsModal(true)
    }

    const theme = useSelector(
        state => state.config.theme
    )

    const elements = [
        { delay: -1600 },
        { delay: -1550 },
        { delay: -1500 },
        { delay: -1450 },
        { delay: -1400 },
        { delay: -1350 },
        { delay: -1300 },
        { delay: -1250 },
        { delay: -1200 },
        { delay: -1150 },
        { delay: -1100 },
        { delay: -1050 },
        { delay: -1000 },
    ];


    return (
        <div className=' grow flex flex-col overflow-hidden'>
            <div className='flex justify-end gap-2 '>
                <MenuSimple
                    closeInsideTouch={false}
                    show={showFilterModal}
                    closeMenu={() => setShowFilterModal(false)}
                    top={32}
                    right={0}
                    label={<SquareIconButton onClick={() => setShowFilterModal(true)} varient={squareButtonVarient.outlined} icon={<IconFilter />} text={'Filter'} />}
                >
                    <div className=' max-w-60 w-60 flex flex-col py-3'>
                        <div className=' text-sm font-bold flex pb-1 justify-start w-full'>By Date</div>
                        <div className='flex flex-col ps-1'>
                            <InputStd2 title='From' type='date' onChange={onChangeSearchParams} value={searchParams[searchParamDef.fromDate]} name={searchParamDef.fromDate} />
                            <InputStd2 title='To' onChange={onChangeSearchParams} value={searchParams[searchParamDef.toDate]} name={searchParamDef.toDate} type='date' />
                        </div>
                        <div className=' text-sm font-bold flex pb-1 justify-start w-full pt-2'>By Ledger</div>
                        <div className='ps-1'>
                            <SelectBoxInputBox option={ledgers} onChange={onChangeSearchParams} value={searchParams[searchParamDef.ledgerId]} name={searchParamDef.ledgerId} className={' grow  basis-full sm:basis-auto'} placeholder={'Party'} title={'Ledger'} />
                        </div>
                        <div className=' w-full flex justify-end pt-2'>
                            <SquareIconButton text={'Search'} onClick={() => { rebuildUi(); setShowFilterModal(false) }} />
                        </div>
                    </div>
                </MenuSimple>
                <SquareIconButton icon={<IconPlus />} text={'Add'} onClick={() => setShowAddModal(true)} />
                <ModalAddBranch show={showAddModal} closeModal={() => setShowAddModal(false)} updateUi={rebuildUi} pushData={(data) => { rows1.push({ id: rows1.length + 1, data }); setRow1([...rows1]) }} />
                <ModalBranchDetails id={selectedEmploye} show={showDetailsModal} closeModal={() => setShowDetailsModal(false)} updateUi={rebuildUi} />

            </div>
            <div className='pt-1 pb-5 grow  overflow-hidden flex flex-col' >
                {isLoading === false ?
                    rows1.length > 0
                        ?
                        <div className=" flex overflow-hidden relative shadow-md sm:rounded-lg">
                            <TableStanderd>
                                <TableStanderd.Head>
                                    {
                                        headers.map(
                                            header => (<th key={header.id} scope="col" className="py-3 px-6">{header.name}</th>)
                                        )
                                    }
                                </TableStanderd.Head>
                                <TableStanderd.Body>
                                    {
                                        rows1.map(
                                            (row, index) => {
                                                if (index === rows1.length - 1) {
                                                    return (
                                                        <TableStanderd.TbRowEnd onClick={() => openDetailsModal(row.id, index)} key={row.id} >
                                                            {
                                                                headers.map(
                                                                    (header, index) => (
                                                                        <TableStanderd.Td  key={index} >{row.data[header.label]}</TableStanderd.Td >
                                                                    )
                                                                )
                                                            }
                                                        </TableStanderd.TbRowEnd>
                                                    )
                                                }

                                                return (
                                                    <TableStanderd.TbRow onClick={() => openDetailsModal(row.id, index)} key={row.id} className={`${theme.state === themeStateDef.PENDING ? 'theme-smooth' : ''} bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-200 hover:dark:bg-gray-600`}>
                                                        {
                                                            headers.map(
                                                                (header, index) => (
                                                                    <TableStanderd.Td key={index} >{row.data[header.label]}</TableStanderd.Td>
                                                                )
                                                            )
                                                        }

                                                    </TableStanderd.TbRow>
                                                )
                                            }
                                        )
                                    }
                                </TableStanderd.Body>
                            </TableStanderd>
                        </div>
                        :
                        <div className=' flex grow dark:text-gray-300 text-3xl font-bold  items-center justify-center theme-smooth'>No Records Found</div>
                    :
                    <div className=' grow flex flex-col gap-2'>


                        {
                            elements.map(
                                (element, index) => (
                                    <div
                                        key={index}
                                        className={`w-full ${index === 0 ? 'h-16' : 'h-11'} bg-gray-600 rounded-md animate-bubblee`}
                                        style={{ animationDelay: `${element.delay}ms` }}
                                    ></div>
                                )
                            )
                        }



                    </div>
                }
            </div>
        </div>
    )
}
